import { useState } from 'react';
import type { Lang } from '../page';

interface ReviewsFAQProps { lang: Lang; }

type LM = Record<Lang, string>;

const reviewTitle: LM = {
  en: 'Customer Testimonials', zh: '客户真实评价', th: 'คำรับรองจากลูกค้า',
  vi: 'Lời Chứng Thực Của Khách Hàng', ms: 'Testimoni Pelanggan',
};
const reviewSub: LM = {
  en: '客户真实反馈', zh: 'Real Customer Feedback', th: 'ความคิดเห็นจากลูกค้าจริง',
  vi: 'Phản hồi thực từ khách hàng', ms: 'Maklum Balas Pelanggan Sebenar',
};
const faqTitle: LM = {
  en: 'Frequently Asked Questions', zh: '常见问题解答', th: 'คำถามที่พบบ่อย',
  vi: 'Câu Hỏi Thường Gặp', ms: 'Soalan Lazim',
};
const faqSub: LM = {
  en: '常见问题', zh: 'FAQ', th: 'FAQ', vi: 'FAQ', ms: 'FAQ',
};

const reviews = [
  {
    rating: 5,
    content: {
      en: 'We have been using this polyimide film in aerospace applications for over three years. The product quality is very stable, with excellent high-temperature resistance that fully meets our stringent technical requirements.',
      zh: '我们在航空航天应用中使用这款聚酰亚胺薄膜已超过三年。产品质量非常稳定，卓越的耐高温性能完全满足我们严格的技术要求。',
      th: 'เราได้ใช้ฟิล์มโพลีอิไมด์นี้ในการใช้งานด้านการบินและอวกาศมานานกว่าสามปี คุณภาพผลิตภัณฑ์มีความเสถียรมาก ทนอุณหภูมิสูงได้ดีเยี่ยม',
      vi: 'Chúng tôi đã sử dụng màng polyimide này trong ứng dụng hàng không vũ trụ hơn ba năm. Chất lượng sản phẩm rất ổn định, khả năng chịu nhiệt cao xuất sắc.',
      ms: 'Kami telah menggunakan filem polyimide ini dalam aplikasi aeroangkasa lebih tiga tahun. Kualiti produk sangat stabil dengan rintangan suhu tinggi yang cemerlang.',
    } as LM,
    author: { en: 'Zhang Wei', zh: '张伟', th: 'Zhang Wei', vi: 'Zhang Wei', ms: 'Zhang Wei' } as LM,
    position: {
      en: 'Materials Engineer · Aerospace Technology Co.',
      zh: '材料工程师 · 航天科技公司',
      th: 'วิศวกรวัสดุ · บริษัทเทคโนโลยีการบินและอวกาศ',
      vi: 'Kỹ Sư Vật Liệu · Công ty Công nghệ Hàng không Vũ trụ',
      ms: 'Jurutera Bahan · Syarikat Teknologi Aeroangkasa',
    } as LM,
    avatar: 'https://public.readdy.ai/ai/img_res/89f1a8c5e4de25f585e4104283740bbd.jpg',
  },
  {
    rating: 5,
    content: {
      en: 'As a motor manufacturer, we have extremely high requirements for insulation materials. This polyimide film has excellent electrical properties and good processability, greatly improving our production efficiency.',
      zh: '作为电机制造商，我们对绝缘材料的要求极为严格。这款聚酰亚胺薄膜电气性能优异，加工性好，大幅提升了我们的生产效率。',
      th: 'ในฐานะผู้ผลิตมอเตอร์ เราต้องการวัสดุฉนวนคุณภาพสูงมาก ฟิล์มโพลีอิไมด์นี้มีคุณสมบัติทางไฟฟ้าที่ยอดเยี่ยมและกระบวนการผลิตที่ดี',
      vi: 'Là nhà sản xuất động cơ, chúng tôi có yêu cầu rất cao về vật liệu cách điện. Màng polyimide này có đặc tính điện tuyệt vời và khả năng gia công tốt.',
      ms: 'Sebagai pengeluar motor, kami mempunyai keperluan yang sangat tinggi untuk bahan penebat. Filem polyimide ini mempunyai sifat elektrik yang cemerlang.',
    } as LM,
    author: { en: 'Li Ming', zh: '李明', th: 'Li Ming', vi: 'Li Ming', ms: 'Li Ming' } as LM,
    position: {
      en: 'Procurement Manager · Motor Manufacturing Enterprise',
      zh: '采购经理 · 电机制造企业',
      th: 'ผู้จัดการจัดซื้อ · บริษัทผลิตมอเตอร์',
      vi: 'Quản Lý Mua Hàng · Doanh nghiệp Sản xuất Động cơ',
      ms: 'Pengurus Perolehan · Perusahaan Pembuatan Motor',
    } as LM,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20manager%20in%20business%20suit%20smiling%20warmly%20in%20modern%20corporate%20office%20with%20professional%20lighting&width=200&height=200&seq=avatar-002&orientation=squarish',
  },
  {
    rating: 5,
    content: {
      en: 'In new energy vehicle battery pack applications, this film performs excellently. Superior insulation performance and strong chemical corrosion resistance help us improve product safety and reliability.',
      zh: '在新能源汽车电池组应用中，这款薄膜表现优异。绝缘性能卓越，化学耐腐蚀性强，帮助我们提升了产品安全性和可靠性。',
      th: 'สำหรับการใช้งานในแบตเตอรี่รถยนต์พลังงานใหม่ ฟิล์มนี้ทำงานได้ดีเยี่ยม คุณสมบัติฉนวนที่เหนือกว่าช่วยเพิ่มความปลอดภัยของผลิตภัณฑ์',
      vi: 'Trong ứng dụng cụm pin xe điện, màng này hoạt động xuất sắc. Hiệu suất cách điện vượt trội và khả năng chống ăn mòn hóa học mạnh.',
      ms: 'Dalam aplikasi pek bateri kenderaan tenaga baharu, filem ini berprestasi cemerlang. Prestasi penebatan unggul membantu meningkatkan keselamatan produk.',
    } as LM,
    author: { en: 'Wang Jun', zh: '王军', th: 'Wang Jun', vi: 'Wang Jun', ms: 'Wang Jun' } as LM,
    position: {
      en: 'Technical Director · New Energy Technology Co.',
      zh: '技术总监 · 新能源科技公司',
      th: 'ผู้อำนวยการด้านเทคนิค · บริษัทเทคโนโลยีพลังงานใหม่',
      vi: 'Giám Đốc Kỹ Thuật · Công ty Công nghệ Năng lượng Mới',
      ms: 'Pengarah Teknikal · Syarikat Teknologi Tenaga Baharu',
    } as LM,
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20executive%20in%20formal%20business%20attire%20with%20confident%20expression%20in%20modern%20high-tech%20office%20environment&width=200&height=200&seq=avatar-003&orientation=squarish',
  },
];

const faqs: Array<{ q: LM; a: LM }> = [
  {
    q: { en: 'What is the minimum order quantity?', zh: '聚酰亚胺薄膜的最小起订量是多少？', th: 'ปริมาณสั่งซื้อขั้นต่ำคือเท่าไร?', vi: 'Số lượng đặt hàng tối thiểu là bao nhiêu?', ms: 'Apakah kuantiti pesanan minimum?' },
    a: { en: 'Our minimum order quantity is 100kg. For new customers, we provide small batch samples for testing to help evaluate product suitability.', zh: '我们的最小起订量为100kg。对于新客户，我们提供小批量样品供测试，帮助您评估产品是否满足应用需求。', th: 'ปริมาณสั่งซื้อขั้นต่ำของเราคือ 100kg สำหรับลูกค้าใหม่เราจัดหาตัวอย่างสำหรับการทดสอบ', vi: 'Số lượng đặt hàng tối thiểu của chúng tôi là 100kg. Đối với khách hàng mới, chúng tôi cung cấp mẫu thử nhỏ.', ms: 'Kuantiti pesanan minimum kami ialah 100kg. Untuk pelanggan baharu, kami menyediakan sampel kecil untuk pengujian.' },
  },
  {
    q: { en: 'What is the delivery time for products?', zh: '产品的交货周期是多久？', th: 'ระยะเวลาส่งมอบสินค้าคือเท่าไร?', vi: 'Thời gian giao hàng là bao lâu?', ms: 'Berapakah tempoh penghantaran produk?' },
    a: { en: 'Standard specification products: 7-15 working days. Custom specification products: 15-30 working days. Expedited service is available based on urgency.', zh: '标准规格产品交货期7-15个工作日。定制规格产品15-30个工作日。可根据紧急程度提供加急服务。', th: 'สินค้าสเปกมาตรฐาน 7-15 วันทำการ สินค้าตามสั่ง 15-30 วันทำการ', vi: 'Sản phẩm tiêu chuẩn: 7-15 ngày làm việc. Sản phẩm tùy chỉnh: 15-30 ngày làm việc.', ms: 'Produk spesifikasi standard: 7-15 hari bekerja. Produk spesifikasi tersuai: 15-30 hari bekerja.' },
  },
  {
    q: { en: 'Do you provide customization services?', zh: '是否提供定制服务？', th: 'คุณให้บริการปรับแต่งสินค้าหรือไม่?', vi: 'Bạn có cung cấp dịch vụ tùy chỉnh không?', ms: 'Adakah anda menyediakan perkhidmatan penyesuaian?' },
    a: { en: 'Yes, we provide comprehensive customization including thickness, width, length, and surface treatment. Our technical team will provide professional solutions.', zh: '是的，我们提供全面定制服务，包括厚度、宽度、长度、表面处理等。技术团队将提供专业解决方案。', th: 'ใช่ เราให้บริการปรับแต่งครบวงจร รวมถึงความหนา ความกว้าง ความยาว และการเคลือบผิว', vi: 'Có, chúng tôi cung cấp dịch vụ tùy chỉnh toàn diện bao gồm độ dày, chiều rộng, chiều dài và xử lý bề mặt.', ms: 'Ya, kami menyediakan penyesuaian menyeluruh termasuk ketebalan, lebar, panjang dan rawatan permukaan.' },
  },
  {
    q: { en: 'How is product quality guaranteed?', zh: '产品质量如何保证？', th: 'คุณภาพของผลิตภัณฑ์ได้รับการรับประกันอย่างไร?', vi: 'Chất lượng sản phẩm được đảm bảo như thế nào?', ms: 'Bagaimana kualiti produk dijamin?' },
    a: { en: 'ISO 9001 certified. Every batch undergoes strict quality testing with complete test reports. Full refund or replacement for any quality issues.', zh: '通过ISO 9001认证。每批产品均经过严格质量检测，附完整检测报告。如有质量问题，全额退款或换货。', th: 'ผ่านการรับรอง ISO 9001 ทุกล็อตผ่านการทดสอบคุณภาพอย่างเข้มงวด พร้อมรายงานการทดสอบครบถ้วน', vi: 'Được chứng nhận ISO 9001. Mỗi lô hàng được kiểm tra chất lượng nghiêm ngặt kèm báo cáo đầy đủ.', ms: 'Diperakui ISO 9001. Setiap lot melalui ujian kualiti yang ketat dengan laporan ujian lengkap.' },
  },
  {
    q: { en: 'Do you provide technical support?', zh: '是否提供技术支持？', th: 'คุณให้การสนับสนุนทางเทคนิคหรือไม่?', vi: 'Bạn có cung cấp hỗ trợ kỹ thuật không?', ms: 'Adakah anda menyediakan sokongan teknikal?' },
    a: { en: 'We have a professional technical support team providing 7×24 online consultation. From product selection to after-sales service, we support you throughout.', zh: '我们提供7×24在线咨询服务。从产品选型、应用指导到售后服务，全程提供专业支持。', th: 'เรามีทีมสนับสนุนทางเทคนิคที่ให้บริการออนไลน์ 7×24 ชั่วโมง ตั้งแต่การเลือกผลิตภัณฑ์ถึงหลังการขาย', vi: 'Đội ngũ hỗ trợ kỹ thuật tư vấn trực tuyến 7×24h, từ lựa chọn sản phẩm đến dịch vụ sau bán hàng.', ms: 'Pasukan sokongan teknikal kami menyediakan perundingan dalam talian 7×24 jam dari pemilihan produk hingga perkhidmatan selepas jualan.' },
  },
  {
    q: { en: 'How to obtain samples?', zh: '如何获取样品？', th: 'จะขอตัวอย่างสินค้าได้อย่างไร?', vi: 'Làm thế nào để lấy mẫu sản phẩm?', ms: 'Bagaimana untuk mendapatkan sampel?' },
    a: { en: 'Contact us via online chat, phone or email. Samples will be shipped within 24 hours. Samples are free, you only cover the shipping cost.', zh: '通过在线客服、电话或邮件联系我们申请样品。24小时内安排发货。样品免费，只需承担运费。', th: 'ติดต่อเราผ่านแชทออนไลน์ โทรศัพท์ หรืออีเมล จะจัดส่งตัวอย่างภายใน 24 ชั่วโมง ฟรีตัวอย่าง', vi: 'Liên hệ qua chat, điện thoại hoặc email. Mẫu sẽ được vận chuyển trong 24 giờ. Mẫu miễn phí, chỉ trả phí vận chuyển.', ms: 'Hubungi kami melalui chat, telefon atau e-mel. Sampel akan dihantar dalam 24 jam. Sampel percuma, hanya perlu menanggung kos penghantaran.' },
  },
];

const certifications = [
  { name: 'ISO 9001', icon: 'ri-award-line' },
  { name: 'RoHS', icon: 'ri-leaf-line' },
  { name: 'REACH', icon: 'ri-shield-check-line' },
  { name: 'UL Certified', icon: 'ri-verified-badge-line' },
];

export default function ReviewsFAQ({ lang }: ReviewsFAQProps) {
  const [currentReview, setCurrentReview] = useState(0);
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);
  const r = reviews[currentReview];

  return (
    <>
      <section className="py-24 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 text-center mb-4">{reviewTitle[lang]}</h2>
          <p className="text-xl text-gray-500 text-center mb-16">{reviewSub[lang]}</p>

          <div className="relative">
            <div className="bg-white rounded-3xl p-12 shadow-xl">
              <div className="inline-flex items-center space-x-2 px-4 py-2 bg-gray-900 text-white rounded-full mb-8">
                <div className="flex space-x-1">
                  {[...Array(r.rating)].map((_, i) => <i key={i} className="ri-star-fill text-amber-400"></i>)}
                </div>
                <span className="font-bold">{r.rating}.0</span>
              </div>
              <blockquote className="text-2xl text-gray-900 leading-relaxed mb-8 font-serif italic">
                "{r.content[lang]}"
              </blockquote>
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 rounded-full overflow-hidden">
                  <img src={r.avatar} alt={r.author.en} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-lg">{r.author[lang]}</div>
                  <div className="text-gray-600 text-sm">{r.position[lang]}</div>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-center space-x-4 mt-8">
              <button
                onClick={() => setCurrentReview((prev) => (prev === 0 ? reviews.length - 1 : prev - 1))}
                className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-lg hover:border-gray-900 transition-colors"
                aria-label="Previous"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex space-x-2">
                {reviews.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentReview(index)}
                    className={`w-2 h-2 rounded-full transition-all ${index === currentReview ? 'bg-gray-900 w-8' : 'bg-gray-300'}`}
                    aria-label={`Review ${index + 1}`}
                  />
                ))}
              </div>
              <button
                onClick={() => setCurrentReview((prev) => (prev === reviews.length - 1 ? 0 : prev + 1))}
                className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors"
                aria-label="Next"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 text-center mb-4">{faqTitle[lang]}</h2>
          <p className="text-xl text-gray-500 text-center mb-16">{faqSub[lang]}</p>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden">
                <button
                  onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                  className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 text-lg pr-4">{faq.q[lang]}</span>
                  <i className={`ri-arrow-down-s-line text-2xl text-gray-600 transition-transform flex-shrink-0 ${openFAQ === index ? 'rotate-180' : ''}`}></i>
                </button>
                {openFAQ === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-600 leading-relaxed">{faq.a[lang]}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="certifications" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-12">
            {certifications.map((cert, index) => (
              <div key={index} className="flex flex-col items-center space-y-2">
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className={`${cert.icon} text-3xl text-amber-500`}></i>
                </div>
                <span className="text-sm font-medium text-gray-700">{cert.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
